import { Signal } from '@angular/core';
import { DialogSize } from '@wcg/frontend-framework';
import {
  AddressDialog,
  AddressMode,
  AddressNew,
  CountryList,
  StateList,
} from '../types';

export abstract class AddressDialogAbstractView implements AddressDialog {
  abstract addressTitle: string;
  abstract dialogSize: DialogSize;
  abstract addressLines: string[];
  abstract $countries: Signal<CountryList>;
  abstract $states: Signal<StateList>;
  abstract fetchCountries(): void;
  abstract fetchStates(countryId: string): void;
}

export type AddressDialogData = {
  facadeService: AddressDialogAbstractView;
  mode: AddressMode;
  currentAddress?: AddressNew;
};
